import React from 'react';
import { Box, Divider, IconButton, Modal, useMediaQuery } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/system';
import styles from './Modals.module.css';

export default function CustomModal({
  open,
  handleClose,
  children,
  level = 0,
  size = 'medium',
  closeIcon = true,
}) {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  const setModalSize = () => {
    if (size === 'large') {
      return '900px';
    }
    if (size === 'small') {
      return '400px';
    }
    return '600px';
  };

  return (
    <Modal open={open} onClose={handleClose} className={styles.modal}>
      <Box
        bgcolor="background.paper"
        boxShadow={3}
        borderRadius="12px"
        p={2}
        className={styles.modalBody}
        style={{
          transform: isDesktop
            ? `translate(${level * 20}px, ${level * 20}px)`
            : 'none',
          width: setModalSize(),
        }}
      >
        {closeIcon && (
          <>
            <IconButton aria-label="delete" size="medium" onClick={handleClose}>
              <CloseIcon />
            </IconButton>
            <Divider className={styles.mt10} />
          </>
        )}

        <div style={{ overflowY: 'auto' }}>{children}</div>
      </Box>
    </Modal>
  );
}

CustomModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  level: PropTypes.number,
  size: PropTypes.string,
  closeIcon: PropTypes.bool,
};
